import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };
  static targets = ["list", "menu", "blink"];

  connect() {
    this.load();
    this.interval = setInterval(() => this.load(), 60000);
  }

  disconnect() {
    clearInterval(this.interval);
  }

  async load() {
    try {
      const response = await fetch(this.urlValue || "/notificacoes/header_dropdown.json");
      const data = await response.json();
      this.render(data);
    } catch (error) {
      console.error("Erro ao carregar notificações:", error);
    }
  }

  render(data) {
    if (!data || !Array.isArray(data)) return;
    const unread = data.filter(n => !n.lida).length;

    const html = `
      <div class="py-3 px-4 bg-secondary text-white">
        <div class="fs-6 fw-medium">Notificações</div>
        <div class="fs-2 fw-medium">${unread > 0 ? `Você tem ${unread} novas` : "Nenhuma nova"}</div>
      </div>

      <div class="message-body" data-simplebar>
        ${
          data.length > 0
            ? data.map(n => `
              <div id="notificacao-${n.id}" class="p-3 d-flex align-items-center dropdown-item gap-3 border-bottom ${n.lida ? "" : "bg-light"}">
                <a href="${n.url || "#"}" class="d-flex align-items-center gap-3 w-100 text-decoration-none text-dark"
                   data-id="${n.id}" data-action="click->notificacoes#clickNotification">
                  <div class="w-100 d-inline-block v-middle">
                    <div class="d-flex align-items-center justify-content-between">
                      <h6 class="mb-1">${n.titulo}</h6>
                      <span class="fs-2 text-nowrap text-muted">
                        ${new Date(n.created_at).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
                      </span>
                    </div>
                    <span class="fs-2 d-block text-truncate text-muted">${n.texto}</span>
                  </div>
                </a>
              </div>
            `).join("")
            : `<div class="p-3 text-center text-muted small">Sem notificações</div>`
        }
      </div>

      <div class="p-3 d-flex gap-2">
        <button class="btn btn-warning w-50 d-flex align-items-center justify-content-center gap-2" id="marcar-todas">
          <iconify-icon icon="solar:check-circle-line-duotone"></iconify-icon>
          <span>Marcar todas como lidas</span>
        </button>
        <a href="/notificacoes" class="btn btn-secondary w-50 d-flex align-items-center justify-content-center gap-2">
          <span>Ver todas</span>
          <iconify-icon icon="solar:alt-arrow-right-outline"></iconify-icon>
        </a>
      </div>
    `;

    const targetMenu = this.hasMenuTarget ? this.menuTarget : this.hasListTarget ? this.listTarget : null;
    if (targetMenu) targetMenu.innerHTML = html;

    // adiciona listener para clicar na notificação
    targetMenu?.querySelectorAll("a[data-action='click->notificacoes#clickNotification']").forEach(link => {
      link.addEventListener("click", e => this.clickNotification(e));
    });

    // listener botão marcar todas
    const btnAll = targetMenu?.querySelector("#marcar-todas");
    btnAll?.addEventListener("click", async (e) => {
      e.preventDefault();
      try {
        await fetch("/notificacoes/marcar_todas", {
          method: "PATCH",
          headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
        });
        this.load();
      } catch (err) {
        console.error("Erro ao marcar todas como lidas", err);
      }
    });

    this.updateBlink(unread);
  }

  async clickNotification(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const id = link.dataset.id;
    const url = link.getAttribute("href");

    try {
      await fetch(`/notificacoes/${id}/marcar_como_lida`, {
        method: "PATCH",
        headers: { "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content },
      });

      const item = document.getElementById(`notificacao-${id}`);
      if (item) item.remove();

      // atualiza blink se não sobrar nenhuma
      const remaining = this.hasListTarget ? this.listTarget.querySelectorAll(".dropdown-item").length : 0;
      this.updateBlink(remaining);

      if (url && url !== "#") window.location.href = url;
    } catch (err) {
      console.error("Erro ao marcar como lida", err);
    }
  }

  updateBlink(unread) {
    if (!this.hasBlinkTarget) return;
    this.blinkTarget.innerHTML = unread > 0 ? `<span class="heartbit"></span><span class="point"></span>` : "";
  }
}
